import { createContext, useContext, useEffect, useRef, useState } from 'react';
import {
  setHandlers,
  initAds,
  showInterstitial as svcInterstitial,
  showRewarded as svcRewarded,
  abort as svcAbort,
} from '../ads/adService.js';

const AdContext = createContext(null);

export function AdProvider({ children }) {
  const [status, setStatus] = useState({
    text: 'Ready for Deployment',
    theme: 'blue',
  });
  const [loader, setLoader] = useState({ show: false, text: 'Initializing...' });
  const initialized = useRef(false);

  useEffect(() => {
    // Wire the ad service's status/loading reporting to React state.
    setHandlers({
      onStatus: (text, theme = 'blue') => setStatus({ text, theme }),
      onLoading: (show, text) =>
        setLoader((prev) => ({ show, text: text ?? prev.text })),
    });

    if (!initialized.current) {
      initialized.current = true;
      // Initialize after load so adsbygoogle.js has a chance to attach.
      if (document.readyState === 'complete') {
        initAds();
      } else {
        window.addEventListener('load', () => initAds(), { once: true });
      }
    }
  }, []);

  const value = {
    status,
    loader,
    showInterstitial: svcInterstitial,
    showRewarded: svcRewarded,
    abort: svcAbort,
  };

  return <AdContext.Provider value={value}>{children}</AdContext.Provider>;
}

export function useAds() {
  const ctx = useContext(AdContext);
  if (!ctx) throw new Error('useAds must be used within an AdProvider');
  return ctx;
}
